export enum OrderByDirection {
  ASC = 'asc',
  DESC = 'DESC'
}
